import { DiscountType } from '@repo/common';

export const calculateItemTotalPrice = (
    price: number,
    quantity: number,
    discountValue: number,
    discountType: DiscountType | null | string = DiscountType.Fixed,
): number => {
    const totalPrice = price * quantity;

    let discount = 0;

    if (discountType === DiscountType.Fixed) {
        discount = discountValue;
    } else if (discountType === DiscountType.Percentage) {
        discount = (totalPrice * discountValue) / 100;
    }

    const totalAfterDiscount = totalPrice - discount;
    return totalAfterDiscount >= 0 ? totalAfterDiscount : 0;
};
